import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchInterceptors } from "../../../Api/fetchInterceptors";

const END_POINT = process.env.REACT_APP_GET_DB_COLLECTION_LIST;
// Define a new action type
const append_New_Collection_Name_In_Db_List =
  "extraReducers/dbList/appendNewCollectionNameInDbList";

export const appendNewCollectionNameInDbList = (dbId, newCollectionInfo) => {
  return {
    type: append_New_Collection_Name_In_Db_List,
    payload: { dbId, newCollectionInfo },
  };
};

export const getDataBaseListWithCollection = createAsyncThunk(
  "auth/user-db/collection-db-list",
  async (_, thunkApi) => {
    try {
      const result = fetchInterceptors(END_POINT, "GET");
      return result;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getDataBaseListWithCollection_Slice = createSlice({
  name: "dashboardApiGetDataBaseListWithCollection",
  initialState: {
    response: null,
    success: false,
    statusCode: null,
    error: null,
    loading: null,
  },
  reducers: {
    setDefault_GetDatabaseList: (state) => {
      state.response = null;
      state.success = false;
      state.statusCode = null;
      state.error = null;
      state.loading = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDataBaseListWithCollection.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDataBaseListWithCollection.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.error = null;
          state.response = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        } else {
          state.response = null;
          state.error = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        }
      })
      .addCase(getDataBaseListWithCollection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(append_New_Collection_Name_In_Db_List, (state, action) => {
        const resultString = JSON.stringify(state); // Log the result as a JSON string
        const dbList = JSON.parse(resultString).response.data.list;
        const dbId = action.payload.dbId;
        const newCollectionInfo = action.payload.newCollectionInfo;

        for (let i = 0; i < dbList.length; i++) {
          if (dbList[i].database_id === dbId) {
            dbList[i].collectionArr.push(newCollectionInfo);
          }
        }
        // Update state immutably
        state.response.data.list = [...dbList];
      });
  },
});

export const { setDefault_GetDatabaseList } =
  getDataBaseListWithCollection_Slice.actions;

export default getDataBaseListWithCollection_Slice.reducer;
